/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrganizationCombo200ResponseCategoriesInnerProductsInner
 */
export interface GetOrganizationCombo200ResponseCategoriesInnerProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    productId: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    priceImpact: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200ResponseCategoriesInnerProductsInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetOrganizationCombo200ResponseCategoriesInnerProductsInner interface.
 */
export function instanceOfGetOrganizationCombo200ResponseCategoriesInnerProductsInner(value: object): value is GetOrganizationCombo200ResponseCategoriesInnerProductsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('priceImpact' in value) || value['priceImpact'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSON(json: any): GetOrganizationCombo200ResponseCategoriesInnerProductsInner {
    return GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombo200ResponseCategoriesInnerProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'categoryId': json['categoryId'],
        'productId': json['productId'],
        'priceImpact': json['priceImpact'],
        'position': json['position'],
        'enabled': json['enabled'],
    };
}

export function GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSON(json: any): GetOrganizationCombo200ResponseCategoriesInnerProductsInner {
    return GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSONTyped(value?: GetOrganizationCombo200ResponseCategoriesInnerProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'categoryId': value['categoryId'],
        'productId': value['productId'],
        'priceImpact': value['priceImpact'],
        'position': value['position'],
        'enabled': value['enabled'],
    };
}

